import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services';
import { Router } from '@angular/router';

import { SharedValidators, CommonServices } from 'src/modules/shared';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import {
  takeUntil,
  tap,
  map,
  distinctUntilChanged,
  debounceTime,
  delay,
} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-invitation',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class InvitationComponent {
  inviteForm: FormGroup;
  inviteFormSuccess: boolean;
  inviteFormError: boolean;

  formSubmitAttempt: boolean;

  relaxed: boolean;

  // global pendng
  pending: boolean;
  success: boolean;
  error: any;

  token: any;
  public usernameLoading = false;
  public emailLoading = false;
  usernameError = true;
  usernameServerError;
  baseUrl;
  private unsubscribe$: Subject<void> = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private route: ActivatedRoute,
    private commonServices: CommonServices,
    private http: HttpClient
  ) {
    this.route.queryParams.subscribe((params) => {
      const token = params['token'];
      this.token = token;
    });
    this.baseUrl = commonServices.baseUrl;
    this.inviteForm = this.fb.group(
      {
        username: ['', [Validators.required, Validators.minLength(5)]],
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        middleName: [''],
        mobileNumber: ['', Validators.required],
        password: ['', [Validators.required, SharedValidators.strongPassword]],
        confirmPassword: [
          '',
          [Validators.required, SharedValidators.strongPassword],
        ],
        // captcha: ["", [Validators.required]],
      },
      {
        validator: SharedValidators.matchingPasswords(
          'password',
          'confirmPassword'
        ),
      }
    );

    this.inviteForm
      .get('username')
      .valueChanges.pipe(
        tap((res) => {
          if (res && res !== '') {
            this.usernameLoading = true;
            this.usernameError = true;
            this.usernameServerError = false;
          }
        }),
        delay(800),
        debounceTime(800),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        if (value && value !== '') {
          this.usernameLoading = true;
          this.usernameError = false;
          this.usernameServerError = false;
          this.http
            .get(`${this.baseUrl}/auth/username_availability/${value}/`)
            .subscribe(
              (res) => {
                this.usernameLoading = false;
                this.usernameError = res['status'];
              },
              (error) => {
                this.usernameLoading = false;
                if (error['status'] !== 404) {
                  this.usernameServerError = false;
                } else {
                  this.usernameServerError = true;
                }
              }
            );
        }
      });
  }

  get username() {
    return this.inviteForm.get('username');
  }

  isFieldValid(field: string) {
    return (
      (!this.inviteForm.get(field).valid &&
        this.inviteForm.get(field).touched) ||
      (this.inviteForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  submitChange() {
    this.inviteFormSuccess = false;
    this.inviteFormError = null;
    if (this.inviteForm.valid && this.usernameError === true) {
      this.pending = true;
      const realbody = this.inviteForm.value;
      realbody['token'] = this.token;
      this.userService
        .userVerification({ token: this.token, body: realbody })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            this.pending = false;
            this.inviteFormSuccess = true;
          },
          (error) => {
            this.pending = false;
            this.inviteFormError =
              error.error?.userMessage ||
              error.error?.errorMessage ||
              error.error?.message ||
              error.error ||
              'An unknown error occurred';
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }
  result = {
    existingContractor: true,
    unreadCount: 0,
    verificationStatus: 'string',
    currentMonitoringStatus: {
      currentUserWorkFlow: true,
      complaintApprovalMonitoringId: 'string',
      dateCreated: '2022-10-06T12:56:26.698Z',
      createdBy: 'string',
      remark: 'string',
      status: 'string',
      dateApproved: '2022-10-06T12:56:26.698Z',
      approvedBy: {
        applications: {
          empty: true,
          traversableAgain: true,
          async: true,
          lazy: true,
          sequential: true,
          ordered: true,
          singleValued: true,
          distinct: true,
          orNull: {
            hideFromDashboard: true,
            ordering: 0,
            paymentCallBackUrl: 'string',
            logoPath: 'string',
            applicationId: 'string',
            applicationName: 'string',
            applicationHost: 'string',
            applicationDescription: 'string',
            dateCreated: '2022-10-06T12:56:26.698Z',
            dateModified: '2022-10-06T12:56:26.698Z',
            modifiedBy: 'string',
            createdBy: 'string',
            actionAdditionalDetails: 'string',
            appRolesRequestUrl: 'string',
            accessTypes: ['ALL'],
            defaultUserRoles: ['string'],
          },
          memoized: true,
        },
        nccVerificationMember: true,
        appUserId: 'string',
        username: 'string',
        appUserEmail: 'string',
        mobileNumber: 'string',
        userType: 'string',
        dateCreated: '2022-10-06T12:56:26.698Z',
        firstName: 'string',
        lastName: 'string',
        middleName: 'string',
        createdBy: 'string',
        active: true,
        emailVerified: true,
        phoneVerified: true,
        image: 'string',
        tour: 'string',
        organizationId: {
          jpaCollaborator: {
            collaboratorId: 'string',
            isGeneric: true,
            address: 'string',
            ordering: 0,
            dateModified: '2022-10-06T12:56:26.698Z',
            modifiedBy: 'string',
            dateCreated: '2022-10-06T12:56:26.698Z',
            createdBy: 'string',
            sector: {
              dateCreated: '2022-10-06T12:56:26.698Z',
              dateModified: '2022-10-06T12:56:26.698Z',
              modifiedBy: 'string',
              createdBy: 'string',
              optionId: 'string',
              optionName: 'string',
              optionDescription: 'string',
              actionAdditionalDetails: 'string',
              optionType: {
                optionTypeId: 'string',
                dateCreated: '2022-10-06T12:56:26.698Z',
                createdBy: 'string',
                optionTypeName: 'string',
              },
              parentOptionId: {},
            },
          },
          jpaContractor: {
            existingContractor: true,
            unreadCount: 0,
            verificationStatus: 'string',
            currentMonitoringStatus: {},
            currentUserWatchingComplaint: true,
            contractorId: 'string',
            tradeName: 'string',
            rcNumber: 'string',
            tinNumber: 'string',
            dateOfRegistration: '2022-10-06T12:56:26.698Z',
            nccId: 'string',
            headOfficeAddressStreet: 'string',
            companyName: 'string',
            phoneNumber: 'string',
            fax: 'string',
            website: 'string',
            headOfficeAddressCity: 'string',
            headOfficeAddressZip: 'string',
            headOfficeAddressPobox: 'string',
            headOfficeAddressPmb: 'string',
            companyContactPhone1: 'string',
            companyContactPhone2: 'string',
            companyContactAlternativeEmail: 'string',
            companyContactEmail: 'string',
            barred: true,
            isLicensee: true,
            isCompanyRegVerified: true,
            oldContractorUsername: 'string',
            certificateNumber: 0,
            companyEmailVerified: true,
            registrationNumber: 'string',
            thirdPartyBusinessNumber: 'string',
            dateModified: '2022-10-06T12:56:26.699Z',
            modifiedBy: 'string',
            dateCreated: '2022-10-06T12:56:26.699Z',
            createdBy: 'string',
            countryOfRegistration: {
              countryCode: 'string',
              countryName: 'string',
              unRegion: 'string',
              unSubregion: 'string',
            },
            actualCompanyType: {
              dateCreated: '2022-10-06T12:56:26.699Z',
              dateModified: '2022-10-06T12:56:26.699Z',
              modifiedBy: 'string',
              createdBy: 'string',
              optionId: 'string',
              optionName: 'string',
              optionDescription: 'string',
              actionAdditionalDetails: 'string',
              optionType: {
                optionTypeId: 'string',
                dateCreated: '2022-10-06T12:56:26.699Z',
                createdBy: 'string',
                optionTypeName: 'string',
              },
              parentOptionId: {},
            },
            thirdPartyBusinessName: {
              dateCreated: '2022-10-06T12:56:26.699Z',
              dateModified: '2022-10-06T12:56:26.699Z',
              modifiedBy: 'string',
              createdBy: 'string',
              optionId: 'string',
              optionName: 'string',
              optionDescription: 'string',
              actionAdditionalDetails: 'string',
              optionType: {
                optionTypeId: 'string',
                dateCreated: '2022-10-06T12:56:26.699Z',
                createdBy: 'string',
                optionTypeName: 'string',
              },
              parentOptionId: {},
            },
            ownershipType: {
              dateCreated: '2022-10-06T12:56:26.699Z',
              dateModified: '2022-10-06T12:56:26.699Z',
              modifiedBy: 'string',
              createdBy: 'string',
              optionId: 'string',
              optionName: 'string',
              optionDescription: 'string',
              actionAdditionalDetails: 'string',
              optionType: {
                optionTypeId: 'string',
                dateCreated: '2022-10-06T12:56:26.699Z',
                createdBy: 'string',
                optionTypeName: 'string',
              },
              parentOptionId: {},
            },
            companyType: {
              dateCreated: '2022-10-06T12:56:26.699Z',
              dateModified: '2022-10-06T12:56:26.699Z',
              modifiedBy: 'string',
              createdBy: 'string',
              optionId: 'string',
              optionName: 'string',
              optionDescription: 'string',
              actionAdditionalDetails: 'string',
              optionType: {
                optionTypeId: 'string',
                dateCreated: '2022-10-06T12:56:26.699Z',
                createdBy: 'string',
                optionTypeName: 'string',
              },
              parentOptionId: {},
            },
            headOfficeAddressState: {
              stateId: 'string',
              stateName: 'string',
              capital: 'string',
              dateCreated: '2022-10-06T12:56:26.699Z',
              createdBy: 'string',
              dateModified: '2022-10-06T12:56:26.699Z',
              modifiedBy: 'string',
              countryCode: {
                countryCode: 'string',
                countryName: 'string',
                unRegion: 'string',
                unSubregion: 'string',
              },
            },
          },
          organizationId: 'string',
          dateCreated: '2022-10-06T12:56:26.699Z',
          createdBy: 'string',
          organizationShortName: 'string',
          organizationDescription: 'string',
          organizationGroup: 'string',
          organizationLongName: 'string',
          logoPath: 'string',
          dateModified: '2022-10-06T12:56:26.699Z',
          modifiedBy: 'string',
          allowedToUseApi: true,
          organizationTypeId: {
            organizationTypeId: 'string',
            organizationTypeName: 'string',
            organizationTypeDescription: 'string',
            dateCreated: '2022-10-06T12:56:26.699Z',
            createdBy: 'string',
          },
          countMetadata: {
            objectId: 'string',
            totalComments: 0,
            totalHiddenComments: 0,
            commentsRead: 0,
          },
        },
        roleId: {
          roleId: 'string',
          roleName: 'string',
          roleDescription: 'string',
          dateCreated: '2022-10-06T12:56:26.699Z',
          dateModified: '2022-10-06T12:56:26.699Z',
          modifiedBy: 'string',
          createdBy: 'string',
          organizationId: {
            jpaCollaborator: {
              collaboratorId: 'string',
              isGeneric: true,
              address: 'string',
              ordering: 0,
              dateModified: '2022-10-06T12:56:26.699Z',
              modifiedBy: 'string',
              dateCreated: '2022-10-06T12:56:26.699Z',
              createdBy: 'string',
              sector: {
                dateCreated: '2022-10-06T12:56:26.699Z',
                dateModified: '2022-10-06T12:56:26.699Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.699Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
            },
            jpaContractor: {
              existingContractor: true,
              unreadCount: 0,
              verificationStatus: 'string',
              currentMonitoringStatus: {},
              currentUserWatchingComplaint: true,
              contractorId: 'string',
              tradeName: 'string',
              rcNumber: 'string',
              tinNumber: 'string',
              dateOfRegistration: '2022-10-06T12:56:26.699Z',
              nccId: 'string',
              headOfficeAddressStreet: 'string',
              companyName: 'string',
              phoneNumber: 'string',
              fax: 'string',
              website: 'string',
              headOfficeAddressCity: 'string',
              headOfficeAddressZip: 'string',
              headOfficeAddressPobox: 'string',
              headOfficeAddressPmb: 'string',
              companyContactPhone1: 'string',
              companyContactPhone2: 'string',
              companyContactAlternativeEmail: 'string',
              companyContactEmail: 'string',
              barred: true,
              isLicensee: true,
              isCompanyRegVerified: true,
              oldContractorUsername: 'string',
              certificateNumber: 0,
              companyEmailVerified: true,
              registrationNumber: 'string',
              thirdPartyBusinessNumber: 'string',
              dateModified: '2022-10-06T12:56:26.699Z',
              modifiedBy: 'string',
              dateCreated: '2022-10-06T12:56:26.699Z',
              createdBy: 'string',
              countryOfRegistration: {
                countryCode: 'string',
                countryName: 'string',
                unRegion: 'string',
                unSubregion: 'string',
              },
              actualCompanyType: {
                dateCreated: '2022-10-06T12:56:26.699Z',
                dateModified: '2022-10-06T12:56:26.699Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.699Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              thirdPartyBusinessName: {
                dateCreated: '2022-10-06T12:56:26.699Z',
                dateModified: '2022-10-06T12:56:26.699Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.699Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              ownershipType: {
                dateCreated: '2022-10-06T12:56:26.699Z',
                dateModified: '2022-10-06T12:56:26.699Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.699Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              companyType: {
                dateCreated: '2022-10-06T12:56:26.699Z',
                dateModified: '2022-10-06T12:56:26.699Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.699Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              headOfficeAddressState: {
                stateId: 'string',
                stateName: 'string',
                capital: 'string',
                dateCreated: '2022-10-06T12:56:26.699Z',
                createdBy: 'string',
                dateModified: '2022-10-06T12:56:26.699Z',
                modifiedBy: 'string',
                countryCode: {
                  countryCode: 'string',
                  countryName: 'string',
                  unRegion: 'string',
                  unSubregion: 'string',
                },
              },
            },
            organizationId: 'string',
            dateCreated: '2022-10-06T12:56:26.699Z',
            createdBy: 'string',
            organizationShortName: 'string',
            organizationDescription: 'string',
            organizationGroup: 'string',
            organizationLongName: 'string',
            logoPath: 'string',
            dateModified: '2022-10-06T12:56:26.699Z',
            modifiedBy: 'string',
            allowedToUseApi: true,
            organizationTypeId: {
              organizationTypeId: 'string',
              organizationTypeName: 'string',
              organizationTypeDescription: 'string',
              dateCreated: '2022-10-06T12:56:26.699Z',
              createdBy: 'string',
            },
            countMetadata: {
              objectId: 'string',
              totalComments: 0,
              totalHiddenComments: 0,
              commentsRead: 0,
            },
          },
        },
        totpEnabled: true,
        organizationUnits: [
          {
            organizationUnitId: 'string',
            unitName: 'string',
            unitDescription: 'string',
            dateCreated: '2022-10-06T12:56:26.699Z',
            createdBy: 'string',
            dateModified: '2022-10-06T12:56:26.699Z',
            modifiedBy: 'string',
            organizationId: 'string',
          },
        ],
        newUser: true,
      },
      complaintApprovalId: {
        complaintApprovalId: 'string',
        actionStatus: 'string',
        dateCreated: '2022-10-06T12:56:26.699Z',
        messageBody: 'string',
        status: 'string',
        dateApproved: '2022-10-06T12:56:26.699Z',
        actionThroughApproval: 'string',
        allowContractorToRespond: true,
        approvedBy: {
          applications: {
            empty: true,
            traversableAgain: true,
            async: true,
            lazy: true,
            sequential: true,
            ordered: true,
            singleValued: true,
            distinct: true,
            orNull: {
              hideFromDashboard: true,
              ordering: 0,
              paymentCallBackUrl: 'string',
              logoPath: 'string',
              applicationId: 'string',
              applicationName: 'string',
              applicationHost: 'string',
              applicationDescription: 'string',
              dateCreated: '2022-10-06T12:56:26.699Z',
              dateModified: '2022-10-06T12:56:26.699Z',
              modifiedBy: 'string',
              createdBy: 'string',
              actionAdditionalDetails: 'string',
              appRolesRequestUrl: 'string',
              accessTypes: ['ALL'],
              defaultUserRoles: ['string'],
            },
            memoized: true,
          },
          nccVerificationMember: true,
          appUserId: 'string',
          username: 'string',
          appUserEmail: 'string',
          mobileNumber: 'string',
          userType: 'string',
          dateCreated: '2022-10-06T12:56:26.699Z',
          firstName: 'string',
          lastName: 'string',
          middleName: 'string',
          createdBy: 'string',
          active: true,
          emailVerified: true,
          phoneVerified: true,
          image: 'string',
          tour: 'string',
          organizationId: {
            jpaCollaborator: {
              collaboratorId: 'string',
              isGeneric: true,
              address: 'string',
              ordering: 0,
              dateModified: '2022-10-06T12:56:26.699Z',
              modifiedBy: 'string',
              dateCreated: '2022-10-06T12:56:26.699Z',
              createdBy: 'string',
              sector: {
                dateCreated: '2022-10-06T12:56:26.699Z',
                dateModified: '2022-10-06T12:56:26.699Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.700Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
            },
            jpaContractor: {
              existingContractor: true,
              unreadCount: 0,
              verificationStatus: 'string',
              currentMonitoringStatus: {},
              currentUserWatchingComplaint: true,
              contractorId: 'string',
              tradeName: 'string',
              rcNumber: 'string',
              tinNumber: 'string',
              dateOfRegistration: '2022-10-06T12:56:26.700Z',
              nccId: 'string',
              headOfficeAddressStreet: 'string',
              companyName: 'string',
              phoneNumber: 'string',
              fax: 'string',
              website: 'string',
              headOfficeAddressCity: 'string',
              headOfficeAddressZip: 'string',
              headOfficeAddressPobox: 'string',
              headOfficeAddressPmb: 'string',
              companyContactPhone1: 'string',
              companyContactPhone2: 'string',
              companyContactAlternativeEmail: 'string',
              companyContactEmail: 'string',
              barred: true,
              isLicensee: true,
              isCompanyRegVerified: true,
              oldContractorUsername: 'string',
              certificateNumber: 0,
              companyEmailVerified: true,
              registrationNumber: 'string',
              thirdPartyBusinessNumber: 'string',
              dateModified: '2022-10-06T12:56:26.700Z',
              modifiedBy: 'string',
              dateCreated: '2022-10-06T12:56:26.700Z',
              createdBy: 'string',
              countryOfRegistration: {
                countryCode: 'string',
                countryName: 'string',
                unRegion: 'string',
                unSubregion: 'string',
              },
              actualCompanyType: {
                dateCreated: '2022-10-06T12:56:26.700Z',
                dateModified: '2022-10-06T12:56:26.700Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.700Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              thirdPartyBusinessName: {
                dateCreated: '2022-10-06T12:56:26.700Z',
                dateModified: '2022-10-06T12:56:26.700Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.700Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              ownershipType: {
                dateCreated: '2022-10-06T12:56:26.700Z',
                dateModified: '2022-10-06T12:56:26.700Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.700Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              companyType: {
                dateCreated: '2022-10-06T12:56:26.700Z',
                dateModified: '2022-10-06T12:56:26.700Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.700Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              headOfficeAddressState: {
                stateId: 'string',
                stateName: 'string',
                capital: 'string',
                dateCreated: '2022-10-06T12:56:26.700Z',
                createdBy: 'string',
                dateModified: '2022-10-06T12:56:26.700Z',
                modifiedBy: 'string',
                countryCode: {
                  countryCode: 'string',
                  countryName: 'string',
                  unRegion: 'string',
                  unSubregion: 'string',
                },
              },
            },
            organizationId: 'string',
            dateCreated: '2022-10-06T12:56:26.700Z',
            createdBy: 'string',
            organizationShortName: 'string',
            organizationDescription: 'string',
            organizationGroup: 'string',
            organizationLongName: 'string',
            logoPath: 'string',
            dateModified: '2022-10-06T12:56:26.700Z',
            modifiedBy: 'string',
            allowedToUseApi: true,
            organizationTypeId: {
              organizationTypeId: 'string',
              organizationTypeName: 'string',
              organizationTypeDescription: 'string',
              dateCreated: '2022-10-06T12:56:26.700Z',
              createdBy: 'string',
            },
            countMetadata: {
              objectId: 'string',
              totalComments: 0,
              totalHiddenComments: 0,
              commentsRead: 0,
            },
          },
          roleId: {
            roleId: 'string',
            roleName: 'string',
            roleDescription: 'string',
            dateCreated: '2022-10-06T12:56:26.700Z',
            dateModified: '2022-10-06T12:56:26.700Z',
            modifiedBy: 'string',
            createdBy: 'string',
            organizationId: {
              jpaCollaborator: {
                collaboratorId: 'string',
                isGeneric: true,
                address: 'string',
                ordering: 0,
                dateModified: '2022-10-06T12:56:26.700Z',
                modifiedBy: 'string',
                dateCreated: '2022-10-06T12:56:26.700Z',
                createdBy: 'string',
                sector: {
                  dateCreated: '2022-10-06T12:56:26.700Z',
                  dateModified: '2022-10-06T12:56:26.700Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.700Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
              },
              jpaContractor: {
                existingContractor: true,
                unreadCount: 0,
                verificationStatus: 'string',
                currentMonitoringStatus: {},
                currentUserWatchingComplaint: true,
                contractorId: 'string',
                tradeName: 'string',
                rcNumber: 'string',
                tinNumber: 'string',
                dateOfRegistration: '2022-10-06T12:56:26.700Z',
                nccId: 'string',
                headOfficeAddressStreet: 'string',
                companyName: 'string',
                phoneNumber: 'string',
                fax: 'string',
                website: 'string',
                headOfficeAddressCity: 'string',
                headOfficeAddressZip: 'string',
                headOfficeAddressPobox: 'string',
                headOfficeAddressPmb: 'string',
                companyContactPhone1: 'string',
                companyContactPhone2: 'string',
                companyContactAlternativeEmail: 'string',
                companyContactEmail: 'string',
                barred: true,
                isLicensee: true,
                isCompanyRegVerified: true,
                oldContractorUsername: 'string',
                certificateNumber: 0,
                companyEmailVerified: true,
                registrationNumber: 'string',
                thirdPartyBusinessNumber: 'string',
                dateModified: '2022-10-06T12:56:26.700Z',
                modifiedBy: 'string',
                dateCreated: '2022-10-06T12:56:26.700Z',
                createdBy: 'string',
                countryOfRegistration: {
                  countryCode: 'string',
                  countryName: 'string',
                  unRegion: 'string',
                  unSubregion: 'string',
                },
                actualCompanyType: {
                  dateCreated: '2022-10-06T12:56:26.700Z',
                  dateModified: '2022-10-06T12:56:26.700Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.700Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                thirdPartyBusinessName: {
                  dateCreated: '2022-10-06T12:56:26.700Z',
                  dateModified: '2022-10-06T12:56:26.700Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.701Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                ownershipType: {
                  dateCreated: '2022-10-06T12:56:26.701Z',
                  dateModified: '2022-10-06T12:56:26.701Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.701Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                companyType: {
                  dateCreated: '2022-10-06T12:56:26.702Z',
                  dateModified: '2022-10-06T12:56:26.702Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.702Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                headOfficeAddressState: {
                  stateId: 'string',
                  stateName: 'string',
                  capital: 'string',
                  dateCreated: '2022-10-06T12:56:26.702Z',
                  createdBy: 'string',
                  dateModified: '2022-10-06T12:56:26.702Z',
                  modifiedBy: 'string',
                  countryCode: {
                    countryCode: 'string',
                    countryName: 'string',
                    unRegion: 'string',
                    unSubregion: 'string',
                  },
                },
              },
              organizationId: 'string',
              dateCreated: '2022-10-06T12:56:26.702Z',
              createdBy: 'string',
              organizationShortName: 'string',
              organizationDescription: 'string',
              organizationGroup: 'string',
              organizationLongName: 'string',
              logoPath: 'string',
              dateModified: '2022-10-06T12:56:26.702Z',
              modifiedBy: 'string',
              allowedToUseApi: true,
              organizationTypeId: {
                organizationTypeId: 'string',
                organizationTypeName: 'string',
                organizationTypeDescription: 'string',
                dateCreated: '2022-10-06T12:56:26.702Z',
                createdBy: 'string',
              },
              countMetadata: {
                objectId: 'string',
                totalComments: 0,
                totalHiddenComments: 0,
                commentsRead: 0,
              },
            },
          },
          totpEnabled: true,
          organizationUnits: [
            {
              organizationUnitId: 'string',
              unitName: 'string',
              unitDescription: 'string',
              dateCreated: '2022-10-06T12:56:26.702Z',
              createdBy: 'string',
              dateModified: '2022-10-06T12:56:26.702Z',
              modifiedBy: 'string',
              organizationId: 'string',
            },
          ],
          newUser: true,
        },
        createdBy: {
          applications: {
            empty: true,
            traversableAgain: true,
            async: true,
            lazy: true,
            sequential: true,
            ordered: true,
            singleValued: true,
            distinct: true,
            orNull: {
              hideFromDashboard: true,
              ordering: 0,
              paymentCallBackUrl: 'string',
              logoPath: 'string',
              applicationId: 'string',
              applicationName: 'string',
              applicationHost: 'string',
              applicationDescription: 'string',
              dateCreated: '2022-10-06T12:56:26.702Z',
              dateModified: '2022-10-06T12:56:26.702Z',
              modifiedBy: 'string',
              createdBy: 'string',
              actionAdditionalDetails: 'string',
              appRolesRequestUrl: 'string',
              accessTypes: ['ALL'],
              defaultUserRoles: ['string'],
            },
            memoized: true,
          },
          nccVerificationMember: true,
          appUserId: 'string',
          username: 'string',
          appUserEmail: 'string',
          mobileNumber: 'string',
          userType: 'string',
          dateCreated: '2022-10-06T12:56:26.702Z',
          firstName: 'string',
          lastName: 'string',
          middleName: 'string',
          createdBy: 'string',
          active: true,
          emailVerified: true,
          phoneVerified: true,
          image: 'string',
          tour: 'string',
          organizationId: {
            jpaCollaborator: {
              collaboratorId: 'string',
              isGeneric: true,
              address: 'string',
              ordering: 0,
              dateModified: '2022-10-06T12:56:26.702Z',
              modifiedBy: 'string',
              dateCreated: '2022-10-06T12:56:26.702Z',
              createdBy: 'string',
              sector: {
                dateCreated: '2022-10-06T12:56:26.703Z',
                dateModified: '2022-10-06T12:56:26.703Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.703Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
            },
            jpaContractor: {
              existingContractor: true,
              unreadCount: 0,
              verificationStatus: 'string',
              currentMonitoringStatus: {},
              currentUserWatchingComplaint: true,
              contractorId: 'string',
              tradeName: 'string',
              rcNumber: 'string',
              tinNumber: 'string',
              dateOfRegistration: '2022-10-06T12:56:26.703Z',
              nccId: 'string',
              headOfficeAddressStreet: 'string',
              companyName: 'string',
              phoneNumber: 'string',
              fax: 'string',
              website: 'string',
              headOfficeAddressCity: 'string',
              headOfficeAddressZip: 'string',
              headOfficeAddressPobox: 'string',
              headOfficeAddressPmb: 'string',
              companyContactPhone1: 'string',
              companyContactPhone2: 'string',
              companyContactAlternativeEmail: 'string',
              companyContactEmail: 'string',
              barred: true,
              isLicensee: true,
              isCompanyRegVerified: true,
              oldContractorUsername: 'string',
              certificateNumber: 0,
              companyEmailVerified: true,
              registrationNumber: 'string',
              thirdPartyBusinessNumber: 'string',
              dateModified: '2022-10-06T12:56:26.703Z',
              modifiedBy: 'string',
              dateCreated: '2022-10-06T12:56:26.703Z',
              createdBy: 'string',
              countryOfRegistration: {
                countryCode: 'string',
                countryName: 'string',
                unRegion: 'string',
                unSubregion: 'string',
              },
              actualCompanyType: {
                dateCreated: '2022-10-06T12:56:26.703Z',
                dateModified: '2022-10-06T12:56:26.703Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.703Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              thirdPartyBusinessName: {
                dateCreated: '2022-10-06T12:56:26.703Z',
                dateModified: '2022-10-06T12:56:26.703Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.703Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              ownershipType: {
                dateCreated: '2022-10-06T12:56:26.703Z',
                dateModified: '2022-10-06T12:56:26.703Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.703Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              companyType: {
                dateCreated: '2022-10-06T12:56:26.703Z',
                dateModified: '2022-10-06T12:56:26.703Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.703Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              headOfficeAddressState: {
                stateId: 'string',
                stateName: 'string',
                capital: 'string',
                dateCreated: '2022-10-06T12:56:26.703Z',
                createdBy: 'string',
                dateModified: '2022-10-06T12:56:26.703Z',
                modifiedBy: 'string',
                countryCode: {
                  countryCode: 'string',
                  countryName: 'string',
                  unRegion: 'string',
                  unSubregion: 'string',
                },
              },
            },
            organizationId: 'string',
            dateCreated: '2022-10-06T12:56:26.703Z',
            createdBy: 'string',
            organizationShortName: 'string',
            organizationDescription: 'string',
            organizationGroup: 'string',
            organizationLongName: 'string',
            logoPath: 'string',
            dateModified: '2022-10-06T12:56:26.703Z',
            modifiedBy: 'string',
            allowedToUseApi: true,
            organizationTypeId: {
              organizationTypeId: 'string',
              organizationTypeName: 'string',
              organizationTypeDescription: 'string',
              dateCreated: '2022-10-06T12:56:26.703Z',
              createdBy: 'string',
            },
            countMetadata: {
              objectId: 'string',
              totalComments: 0,
              totalHiddenComments: 0,
              commentsRead: 0,
            },
          },
          roleId: {
            roleId: 'string',
            roleName: 'string',
            roleDescription: 'string',
            dateCreated: '2022-10-06T12:56:26.703Z',
            dateModified: '2022-10-06T12:56:26.703Z',
            modifiedBy: 'string',
            createdBy: 'string',
            organizationId: {
              jpaCollaborator: {
                collaboratorId: 'string',
                isGeneric: true,
                address: 'string',
                ordering: 0,
                dateModified: '2022-10-06T12:56:26.703Z',
                modifiedBy: 'string',
                dateCreated: '2022-10-06T12:56:26.703Z',
                createdBy: 'string',
                sector: {
                  dateCreated: '2022-10-06T12:56:26.703Z',
                  dateModified: '2022-10-06T12:56:26.703Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.703Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
              },
              jpaContractor: {
                existingContractor: true,
                unreadCount: 0,
                verificationStatus: 'string',
                currentMonitoringStatus: {},
                currentUserWatchingComplaint: true,
                contractorId: 'string',
                tradeName: 'string',
                rcNumber: 'string',
                tinNumber: 'string',
                dateOfRegistration: '2022-10-06T12:56:26.703Z',
                nccId: 'string',
                headOfficeAddressStreet: 'string',
                companyName: 'string',
                phoneNumber: 'string',
                fax: 'string',
                website: 'string',
                headOfficeAddressCity: 'string',
                headOfficeAddressZip: 'string',
                headOfficeAddressPobox: 'string',
                headOfficeAddressPmb: 'string',
                companyContactPhone1: 'string',
                companyContactPhone2: 'string',
                companyContactAlternativeEmail: 'string',
                companyContactEmail: 'string',
                barred: true,
                isLicensee: true,
                isCompanyRegVerified: true,
                oldContractorUsername: 'string',
                certificateNumber: 0,
                companyEmailVerified: true,
                registrationNumber: 'string',
                thirdPartyBusinessNumber: 'string',
                dateModified: '2022-10-06T12:56:26.704Z',
                modifiedBy: 'string',
                dateCreated: '2022-10-06T12:56:26.704Z',
                createdBy: 'string',
                countryOfRegistration: {
                  countryCode: 'string',
                  countryName: 'string',
                  unRegion: 'string',
                  unSubregion: 'string',
                },
                actualCompanyType: {
                  dateCreated: '2022-10-06T12:56:26.704Z',
                  dateModified: '2022-10-06T12:56:26.704Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.704Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                thirdPartyBusinessName: {
                  dateCreated: '2022-10-06T12:56:26.704Z',
                  dateModified: '2022-10-06T12:56:26.704Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.704Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                ownershipType: {
                  dateCreated: '2022-10-06T12:56:26.704Z',
                  dateModified: '2022-10-06T12:56:26.704Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.704Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                companyType: {
                  dateCreated: '2022-10-06T12:56:26.704Z',
                  dateModified: '2022-10-06T12:56:26.704Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.704Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                headOfficeAddressState: {
                  stateId: 'string',
                  stateName: 'string',
                  capital: 'string',
                  dateCreated: '2022-10-06T12:56:26.704Z',
                  createdBy: 'string',
                  dateModified: '2022-10-06T12:56:26.704Z',
                  modifiedBy: 'string',
                  countryCode: {
                    countryCode: 'string',
                    countryName: 'string',
                    unRegion: 'string',
                    unSubregion: 'string',
                  },
                },
              },
              organizationId: 'string',
              dateCreated: '2022-10-06T12:56:26.704Z',
              createdBy: 'string',
              organizationShortName: 'string',
              organizationDescription: 'string',
              organizationGroup: 'string',
              organizationLongName: 'string',
              logoPath: 'string',
              dateModified: '2022-10-06T12:56:26.705Z',
              modifiedBy: 'string',
              allowedToUseApi: true,
              organizationTypeId: {
                organizationTypeId: 'string',
                organizationTypeName: 'string',
                organizationTypeDescription: 'string',
                dateCreated: '2022-10-06T12:56:26.705Z',
                createdBy: 'string',
              },
              countMetadata: {
                objectId: 'string',
                totalComments: 0,
                totalHiddenComments: 0,
                commentsRead: 0,
              },
            },
          },
          totpEnabled: true,
          organizationUnits: [
            {
              organizationUnitId: 'string',
              unitName: 'string',
              unitDescription: 'string',
              dateCreated: '2022-10-06T12:56:26.705Z',
              createdBy: 'string',
              dateModified: '2022-10-06T12:56:26.705Z',
              modifiedBy: 'string',
              organizationId: 'string',
            },
          ],
          newUser: true,
        },
        escalatingCollaboratorId: {
          collaboratorId: 'string',
          isGeneric: true,
          address: 'string',
          ordering: 0,
          dateModified: '2022-10-06T12:56:26.705Z',
          modifiedBy: 'string',
          dateCreated: '2022-10-06T12:56:26.705Z',
          createdBy: 'string',
          sector: {
            dateCreated: '2022-10-06T12:56:26.705Z',
            dateModified: '2022-10-06T12:56:26.705Z',
            modifiedBy: 'string',
            createdBy: 'string',
            optionId: 'string',
            optionName: 'string',
            optionDescription: 'string',
            actionAdditionalDetails: 'string',
            optionType: {
              optionTypeId: 'string',
              dateCreated: '2022-10-06T12:56:26.705Z',
              createdBy: 'string',
              optionTypeName: 'string',
            },
            parentOptionId: {},
          },
        },
        complaintMessageAwaitingApproval: {
          messageId: 'string',
          messageBody: 'string',
          dateCreated: '2022-10-06T12:56:26.705Z',
          allowContractorToRespond: true,
          contractorResponded: true,
          awaitingApproval: true,
          deleted: true,
          createdBy: {
            applications: {
              empty: true,
              traversableAgain: true,
              async: true,
              lazy: true,
              sequential: true,
              ordered: true,
              singleValued: true,
              distinct: true,
              orNull: {
                hideFromDashboard: true,
                ordering: 0,
                paymentCallBackUrl: 'string',
                logoPath: 'string',
                applicationId: 'string',
                applicationName: 'string',
                applicationHost: 'string',
                applicationDescription: 'string',
                dateCreated: '2022-10-06T12:56:26.705Z',
                dateModified: '2022-10-06T12:56:26.705Z',
                modifiedBy: 'string',
                createdBy: 'string',
                actionAdditionalDetails: 'string',
                appRolesRequestUrl: 'string',
                accessTypes: ['ALL'],
                defaultUserRoles: ['string'],
              },
              memoized: true,
            },
            nccVerificationMember: true,
            appUserId: 'string',
            username: 'string',
            appUserEmail: 'string',
            mobileNumber: 'string',
            userType: 'string',
            dateCreated: '2022-10-06T12:56:26.706Z',
            firstName: 'string',
            lastName: 'string',
            middleName: 'string',
            createdBy: 'string',
            active: true,
            emailVerified: true,
            phoneVerified: true,
            image: 'string',
            tour: 'string',
            organizationId: {
              jpaCollaborator: {
                collaboratorId: 'string',
                isGeneric: true,
                address: 'string',
                ordering: 0,
                dateModified: '2022-10-06T12:56:26.706Z',
                modifiedBy: 'string',
                dateCreated: '2022-10-06T12:56:26.706Z',
                createdBy: 'string',
                sector: {
                  dateCreated: '2022-10-06T12:56:26.706Z',
                  dateModified: '2022-10-06T12:56:26.706Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
              },
              jpaContractor: {
                existingContractor: true,
                unreadCount: 0,
                verificationStatus: 'string',
                currentMonitoringStatus: {},
                currentUserWatchingComplaint: true,
                contractorId: 'string',
                tradeName: 'string',
                rcNumber: 'string',
                tinNumber: 'string',
                dateOfRegistration: '2022-10-06T12:56:26.706Z',
                nccId: 'string',
                headOfficeAddressStreet: 'string',
                companyName: 'string',
                phoneNumber: 'string',
                fax: 'string',
                website: 'string',
                headOfficeAddressCity: 'string',
                headOfficeAddressZip: 'string',
                headOfficeAddressPobox: 'string',
                headOfficeAddressPmb: 'string',
                companyContactPhone1: 'string',
                companyContactPhone2: 'string',
                companyContactAlternativeEmail: 'string',
                companyContactEmail: 'string',
                barred: true,
                isLicensee: true,
                isCompanyRegVerified: true,
                oldContractorUsername: 'string',
                certificateNumber: 0,
                companyEmailVerified: true,
                registrationNumber: 'string',
                thirdPartyBusinessNumber: 'string',
                dateModified: '2022-10-06T12:56:26.706Z',
                modifiedBy: 'string',
                dateCreated: '2022-10-06T12:56:26.706Z',
                createdBy: 'string',
                countryOfRegistration: {
                  countryCode: 'string',
                  countryName: 'string',
                  unRegion: 'string',
                  unSubregion: 'string',
                },
                actualCompanyType: {
                  dateCreated: '2022-10-06T12:56:26.706Z',
                  dateModified: '2022-10-06T12:56:26.706Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                thirdPartyBusinessName: {
                  dateCreated: '2022-10-06T12:56:26.706Z',
                  dateModified: '2022-10-06T12:56:26.706Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                ownershipType: {
                  dateCreated: '2022-10-06T12:56:26.706Z',
                  dateModified: '2022-10-06T12:56:26.706Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                companyType: {
                  dateCreated: '2022-10-06T12:56:26.706Z',
                  dateModified: '2022-10-06T12:56:26.706Z',
                  modifiedBy: 'string',
                  createdBy: 'string',
                  optionId: 'string',
                  optionName: 'string',
                  optionDescription: 'string',
                  actionAdditionalDetails: 'string',
                  optionType: {
                    optionTypeId: 'string',
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    createdBy: 'string',
                    optionTypeName: 'string',
                  },
                  parentOptionId: {},
                },
                headOfficeAddressState: {
                  stateId: 'string',
                  stateName: 'string',
                  capital: 'string',
                  dateCreated: '2022-10-06T12:56:26.706Z',
                  createdBy: 'string',
                  dateModified: '2022-10-06T12:56:26.706Z',
                  modifiedBy: 'string',
                  countryCode: {
                    countryCode: 'string',
                    countryName: 'string',
                    unRegion: 'string',
                    unSubregion: 'string',
                  },
                },
              },
              organizationId: 'string',
              dateCreated: '2022-10-06T12:56:26.706Z',
              createdBy: 'string',
              organizationShortName: 'string',
              organizationDescription: 'string',
              organizationGroup: 'string',
              organizationLongName: 'string',
              logoPath: 'string',
              dateModified: '2022-10-06T12:56:26.706Z',
              modifiedBy: 'string',
              allowedToUseApi: true,
              organizationTypeId: {
                organizationTypeId: 'string',
                organizationTypeName: 'string',
                organizationTypeDescription: 'string',
                dateCreated: '2022-10-06T12:56:26.706Z',
                createdBy: 'string',
              },
              countMetadata: {
                objectId: 'string',
                totalComments: 0,
                totalHiddenComments: 0,
                commentsRead: 0,
              },
            },
            roleId: {
              roleId: 'string',
              roleName: 'string',
              roleDescription: 'string',
              dateCreated: '2022-10-06T12:56:26.706Z',
              dateModified: '2022-10-06T12:56:26.706Z',
              modifiedBy: 'string',
              createdBy: 'string',
              organizationId: {
                jpaCollaborator: {
                  collaboratorId: 'string',
                  isGeneric: true,
                  address: 'string',
                  ordering: 0,
                  dateModified: '2022-10-06T12:56:26.706Z',
                  modifiedBy: 'string',
                  dateCreated: '2022-10-06T12:56:26.706Z',
                  createdBy: 'string',
                  sector: {
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    dateModified: '2022-10-06T12:56:26.706Z',
                    modifiedBy: 'string',
                    createdBy: 'string',
                    optionId: 'string',
                    optionName: 'string',
                    optionDescription: 'string',
                    actionAdditionalDetails: 'string',
                    optionType: {
                      optionTypeId: 'string',
                      dateCreated: '2022-10-06T12:56:26.706Z',
                      createdBy: 'string',
                      optionTypeName: 'string',
                    },
                    parentOptionId: {},
                  },
                },
                jpaContractor: {
                  existingContractor: true,
                  unreadCount: 0,
                  verificationStatus: 'string',
                  currentMonitoringStatus: {},
                  currentUserWatchingComplaint: true,
                  contractorId: 'string',
                  tradeName: 'string',
                  rcNumber: 'string',
                  tinNumber: 'string',
                  dateOfRegistration: '2022-10-06T12:56:26.706Z',
                  nccId: 'string',
                  headOfficeAddressStreet: 'string',
                  companyName: 'string',
                  phoneNumber: 'string',
                  fax: 'string',
                  website: 'string',
                  headOfficeAddressCity: 'string',
                  headOfficeAddressZip: 'string',
                  headOfficeAddressPobox: 'string',
                  headOfficeAddressPmb: 'string',
                  companyContactPhone1: 'string',
                  companyContactPhone2: 'string',
                  companyContactAlternativeEmail: 'string',
                  companyContactEmail: 'string',
                  barred: true,
                  isLicensee: true,
                  isCompanyRegVerified: true,
                  oldContractorUsername: 'string',
                  certificateNumber: 0,
                  companyEmailVerified: true,
                  registrationNumber: 'string',
                  thirdPartyBusinessNumber: 'string',
                  dateModified: '2022-10-06T12:56:26.706Z',
                  modifiedBy: 'string',
                  dateCreated: '2022-10-06T12:56:26.706Z',
                  createdBy: 'string',
                  countryOfRegistration: {
                    countryCode: 'string',
                    countryName: 'string',
                    unRegion: 'string',
                    unSubregion: 'string',
                  },
                  actualCompanyType: {
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    dateModified: '2022-10-06T12:56:26.706Z',
                    modifiedBy: 'string',
                    createdBy: 'string',
                    optionId: 'string',
                    optionName: 'string',
                    optionDescription: 'string',
                    actionAdditionalDetails: 'string',
                    optionType: {
                      optionTypeId: 'string',
                      dateCreated: '2022-10-06T12:56:26.706Z',
                      createdBy: 'string',
                      optionTypeName: 'string',
                    },
                    parentOptionId: {},
                  },
                  thirdPartyBusinessName: {
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    dateModified: '2022-10-06T12:56:26.706Z',
                    modifiedBy: 'string',
                    createdBy: 'string',
                    optionId: 'string',
                    optionName: 'string',
                    optionDescription: 'string',
                    actionAdditionalDetails: 'string',
                    optionType: {
                      optionTypeId: 'string',
                      dateCreated: '2022-10-06T12:56:26.706Z',
                      createdBy: 'string',
                      optionTypeName: 'string',
                    },
                    parentOptionId: {},
                  },
                  ownershipType: {
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    dateModified: '2022-10-06T12:56:26.706Z',
                    modifiedBy: 'string',
                    createdBy: 'string',
                    optionId: 'string',
                    optionName: 'string',
                    optionDescription: 'string',
                    actionAdditionalDetails: 'string',
                    optionType: {
                      optionTypeId: 'string',
                      dateCreated: '2022-10-06T12:56:26.706Z',
                      createdBy: 'string',
                      optionTypeName: 'string',
                    },
                    parentOptionId: {},
                  },
                  companyType: {
                    dateCreated: '2022-10-06T12:56:26.706Z',
                    dateModified: '2022-10-06T12:56:26.706Z',
                    modifiedBy: 'string',
                    createdBy: 'string',
                    optionId: 'string',
                    optionName: 'string',
                    optionDescription: 'string',
                    actionAdditionalDetails: 'string',
                    optionType: {
                      optionTypeId: 'string',
                      dateCreated: '2022-10-06T12:56:26.711Z',
                      createdBy: 'string',
                      optionTypeName: 'string',
                    },
                    parentOptionId: {},
                  },
                  headOfficeAddressState: {
                    stateId: 'string',
                    stateName: 'string',
                    capital: 'string',
                    dateCreated: '2022-10-06T12:56:26.711Z',
                    createdBy: 'string',
                    dateModified: '2022-10-06T12:56:26.711Z',
                    modifiedBy: 'string',
                    countryCode: {
                      countryCode: 'string',
                      countryName: 'string',
                      unRegion: 'string',
                      unSubregion: 'string',
                    },
                  },
                },
                organizationId: 'string',
                dateCreated: '2022-10-06T12:56:26.711Z',
                createdBy: 'string',
                organizationShortName: 'string',
                organizationDescription: 'string',
                organizationGroup: 'string',
                organizationLongName: 'string',
                logoPath: 'string',
                dateModified: '2022-10-06T12:56:26.711Z',
                modifiedBy: 'string',
                allowedToUseApi: true,
                organizationTypeId: {
                  organizationTypeId: 'string',
                  organizationTypeName: 'string',
                  organizationTypeDescription: 'string',
                  dateCreated: '2022-10-06T12:56:26.711Z',
                  createdBy: 'string',
                },
                countMetadata: {
                  objectId: 'string',
                  totalComments: 0,
                  totalHiddenComments: 0,
                  commentsRead: 0,
                },
              },
            },
            totpEnabled: true,
            organizationUnits: [
              {
                organizationUnitId: 'string',
                unitName: 'string',
                unitDescription: 'string',
                dateCreated: '2022-10-06T12:56:26.711Z',
                createdBy: 'string',
                dateModified: '2022-10-06T12:56:26.711Z',
                modifiedBy: 'string',
                organizationId: 'string',
              },
            ],
            newUser: true,
          },
          parentMessageId: {},
          contractorId: {
            existingContractor: true,
            unreadCount: 0,
            verificationStatus: 'string',
            currentMonitoringStatus: {},
            currentUserWatchingComplaint: true,
            contractorId: 'string',
            tradeName: 'string',
            rcNumber: 'string',
            tinNumber: 'string',
            dateOfRegistration: '2022-10-06T12:56:26.711Z',
            nccId: 'string',
            headOfficeAddressStreet: 'string',
            companyName: 'string',
            phoneNumber: 'string',
            fax: 'string',
            website: 'string',
            headOfficeAddressCity: 'string',
            headOfficeAddressZip: 'string',
            headOfficeAddressPobox: 'string',
            headOfficeAddressPmb: 'string',
            companyContactPhone1: 'string',
            companyContactPhone2: 'string',
            companyContactAlternativeEmail: 'string',
            companyContactEmail: 'string',
            barred: true,
            isLicensee: true,
            isCompanyRegVerified: true,
            oldContractorUsername: 'string',
            certificateNumber: 0,
            companyEmailVerified: true,
            registrationNumber: 'string',
            thirdPartyBusinessNumber: 'string',
            dateModified: '2022-10-06T12:56:26.711Z',
            modifiedBy: 'string',
            dateCreated: '2022-10-06T12:56:26.711Z',
            createdBy: 'string',
            countryOfRegistration: {
              countryCode: 'string',
              countryName: 'string',
              unRegion: 'string',
              unSubregion: 'string',
            },
            actualCompanyType: {
              dateCreated: '2022-10-06T12:56:26.711Z',
              dateModified: '2022-10-06T12:56:26.711Z',
              modifiedBy: 'string',
              createdBy: 'string',
              optionId: 'string',
              optionName: 'string',
              optionDescription: 'string',
              actionAdditionalDetails: 'string',
              optionType: {
                optionTypeId: 'string',
                dateCreated: '2022-10-06T12:56:26.711Z',
                createdBy: 'string',
                optionTypeName: 'string',
              },
              parentOptionId: {},
            },
            thirdPartyBusinessName: {
              dateCreated: '2022-10-06T12:56:26.711Z',
              dateModified: '2022-10-06T12:56:26.711Z',
              modifiedBy: 'string',
              createdBy: 'string',
              optionId: 'string',
              optionName: 'string',
              optionDescription: 'string',
              actionAdditionalDetails: 'string',
              optionType: {
                optionTypeId: 'string',
                dateCreated: '2022-10-06T12:56:26.711Z',
                createdBy: 'string',
                optionTypeName: 'string',
              },
              parentOptionId: {},
            },
            ownershipType: {
              dateCreated: '2022-10-06T12:56:26.711Z',
              dateModified: '2022-10-06T12:56:26.711Z',
              modifiedBy: 'string',
              createdBy: 'string',
              optionId: 'string',
              optionName: 'string',
              optionDescription: 'string',
              actionAdditionalDetails: 'string',
              optionType: {
                optionTypeId: 'string',
                dateCreated: '2022-10-06T12:56:26.711Z',
                createdBy: 'string',
                optionTypeName: 'string',
              },
              parentOptionId: {},
            },
            companyType: {
              dateCreated: '2022-10-06T12:56:26.711Z',
              dateModified: '2022-10-06T12:56:26.711Z',
              modifiedBy: 'string',
              createdBy: 'string',
              optionId: 'string',
              optionName: 'string',
              optionDescription: 'string',
              actionAdditionalDetails: 'string',
              optionType: {
                optionTypeId: 'string',
                dateCreated: '2022-10-06T12:56:26.711Z',
                createdBy: 'string',
                optionTypeName: 'string',
              },
              parentOptionId: {},
            },
            headOfficeAddressState: {
              stateId: 'string',
              stateName: 'string',
              capital: 'string',
              dateCreated: '2022-10-06T12:56:26.711Z',
              createdBy: 'string',
              dateModified: '2022-10-06T12:56:26.711Z',
              modifiedBy: 'string',
              countryCode: {
                countryCode: 'string',
                countryName: 'string',
                unRegion: 'string',
                unSubregion: 'string',
              },
            },
          },
          createdByOrganizationId: {
            jpaCollaborator: {
              collaboratorId: 'string',
              isGeneric: true,
              address: 'string',
              ordering: 0,
              dateModified: '2022-10-06T12:56:26.711Z',
              modifiedBy: 'string',
              dateCreated: '2022-10-06T12:56:26.711Z',
              createdBy: 'string',
              sector: {
                dateCreated: '2022-10-06T12:56:26.711Z',
                dateModified: '2022-10-06T12:56:26.711Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.711Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
            },
            jpaContractor: {
              existingContractor: true,
              unreadCount: 0,
              verificationStatus: 'string',
              currentMonitoringStatus: {},
              currentUserWatchingComplaint: true,
              contractorId: 'string',
              tradeName: 'string',
              rcNumber: 'string',
              tinNumber: 'string',
              dateOfRegistration: '2022-10-06T12:56:26.711Z',
              nccId: 'string',
              headOfficeAddressStreet: 'string',
              companyName: 'string',
              phoneNumber: 'string',
              fax: 'string',
              website: 'string',
              headOfficeAddressCity: 'string',
              headOfficeAddressZip: 'string',
              headOfficeAddressPobox: 'string',
              headOfficeAddressPmb: 'string',
              companyContactPhone1: 'string',
              companyContactPhone2: 'string',
              companyContactAlternativeEmail: 'string',
              companyContactEmail: 'string',
              barred: true,
              isLicensee: true,
              isCompanyRegVerified: true,
              oldContractorUsername: 'string',
              certificateNumber: 0,
              companyEmailVerified: true,
              registrationNumber: 'string',
              thirdPartyBusinessNumber: 'string',
              dateModified: '2022-10-06T12:56:26.711Z',
              modifiedBy: 'string',
              dateCreated: '2022-10-06T12:56:26.711Z',
              createdBy: 'string',
              countryOfRegistration: {
                countryCode: 'string',
                countryName: 'string',
                unRegion: 'string',
                unSubregion: 'string',
              },
              actualCompanyType: {
                dateCreated: '2022-10-06T12:56:26.711Z',
                dateModified: '2022-10-06T12:56:26.711Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.711Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              thirdPartyBusinessName: {
                dateCreated: '2022-10-06T12:56:26.711Z',
                dateModified: '2022-10-06T12:56:26.711Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.711Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              ownershipType: {
                dateCreated: '2022-10-06T12:56:26.711Z',
                dateModified: '2022-10-06T12:56:26.711Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.711Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              companyType: {
                dateCreated: '2022-10-06T12:56:26.711Z',
                dateModified: '2022-10-06T12:56:26.711Z',
                modifiedBy: 'string',
                createdBy: 'string',
                optionId: 'string',
                optionName: 'string',
                optionDescription: 'string',
                actionAdditionalDetails: 'string',
                optionType: {
                  optionTypeId: 'string',
                  dateCreated: '2022-10-06T12:56:26.711Z',
                  createdBy: 'string',
                  optionTypeName: 'string',
                },
                parentOptionId: {},
              },
              headOfficeAddressState: {
                stateId: 'string',
                stateName: 'string',
                capital: 'string',
                dateCreated: '2022-10-06T12:56:26.711Z',
                createdBy: 'string',
                dateModified: '2022-10-06T12:56:26.711Z',
                modifiedBy: 'string',
                countryCode: {
                  countryCode: 'string',
                  countryName: 'string',
                  unRegion: 'string',
                  unSubregion: 'string',
                },
              },
            },
            organizationId: 'string',
            dateCreated: '2022-10-06T12:56:26.711Z',
            createdBy: 'string',
            organizationShortName: 'string',
            organizationDescription: 'string',
            organizationGroup: 'string',
            organizationLongName: 'string',
            logoPath: 'string',
            dateModified: '2022-10-06T12:56:26.711Z',
            modifiedBy: 'string',
            allowedToUseApi: true,
            organizationTypeId: {
              organizationTypeId: 'string',
              organizationTypeName: 'string',
              organizationTypeDescription: 'string',
              dateCreated: '2022-10-06T12:56:26.711Z',
              createdBy: 'string',
            },
            countMetadata: {
              objectId: 'string',
              totalComments: 0,
              totalHiddenComments: 0,
              commentsRead: 0,
            },
          },
          fileStorageId: {
            fileDescription: 'string',
            fileStorageId: 'string',
            fileName: 'string',
            filePath: 'string',
            byteSize: 0,
            dateCreated: '2022-10-06T12:56:26.712Z',
            createdBy: 'string',
            dateModified: '2022-10-06T12:56:26.712Z',
            modifiedBy: 'string',
            extensionGroup: 'string',
            extension: 'string',
            attachment: true,
          },
        },
        contractorId: {
          existingContractor: true,
          unreadCount: 0,
          verificationStatus: 'string',
          currentMonitoringStatus: {},
          currentUserWatchingComplaint: true,
          contractorId: 'string',
          tradeName: 'string',
          rcNumber: 'string',
          tinNumber: 'string',
          dateOfRegistration: '2022-10-06T12:56:26.712Z',
          nccId: 'string',
          headOfficeAddressStreet: 'string',
          companyName: 'string',
          phoneNumber: 'string',
          fax: 'string',
          website: 'string',
          headOfficeAddressCity: 'string',
          headOfficeAddressZip: 'string',
          headOfficeAddressPobox: 'string',
          headOfficeAddressPmb: 'string',
          companyContactPhone1: 'string',
          companyContactPhone2: 'string',
          companyContactAlternativeEmail: 'string',
          companyContactEmail: 'string',
          barred: true,
          isLicensee: true,
          isCompanyRegVerified: true,
          oldContractorUsername: 'string',
          certificateNumber: 0,
          companyEmailVerified: true,
          registrationNumber: 'string',
          thirdPartyBusinessNumber: 'string',
          dateModified: '2022-10-06T12:56:26.712Z',
          modifiedBy: 'string',
          dateCreated: '2022-10-06T12:56:26.712Z',
          createdBy: 'string',
          countryOfRegistration: {
            countryCode: 'string',
            countryName: 'string',
            unRegion: 'string',
            unSubregion: 'string',
          },
          actualCompanyType: {
            dateCreated: '2022-10-06T12:56:26.712Z',
            dateModified: '2022-10-06T12:56:26.712Z',
            modifiedBy: 'string',
            createdBy: 'string',
            optionId: 'string',
            optionName: 'string',
            optionDescription: 'string',
            actionAdditionalDetails: 'string',
            optionType: {
              optionTypeId: 'string',
              dateCreated: '2022-10-06T12:56:26.712Z',
              createdBy: 'string',
              optionTypeName: 'string',
            },
            parentOptionId: {},
          },
          thirdPartyBusinessName: {
            dateCreated: '2022-10-06T12:56:26.712Z',
            dateModified: '2022-10-06T12:56:26.712Z',
            modifiedBy: 'string',
            createdBy: 'string',
            optionId: 'string',
            optionName: 'string',
            optionDescription: 'string',
            actionAdditionalDetails: 'string',
            optionType: {
              optionTypeId: 'string',
              dateCreated: '2022-10-06T12:56:26.712Z',
              createdBy: 'string',
              optionTypeName: 'string',
            },
            parentOptionId: {},
          },
          ownershipType: {
            dateCreated: '2022-10-06T12:56:26.712Z',
            dateModified: '2022-10-06T12:56:26.712Z',
            modifiedBy: 'string',
            createdBy: 'string',
            optionId: 'string',
            optionName: 'string',
            optionDescription: 'string',
            actionAdditionalDetails: 'string',
            optionType: {
              optionTypeId: 'string',
              dateCreated: '2022-10-06T12:56:26.712Z',
              createdBy: 'string',
              optionTypeName: 'string',
            },
            parentOptionId: {},
          },
          companyType: {
            dateCreated: '2022-10-06T12:56:26.712Z',
            dateModified: '2022-10-06T12:56:26.712Z',
            modifiedBy: 'string',
            createdBy: 'string',
            optionId: 'string',
            optionName: 'string',
            optionDescription: 'string',
            actionAdditionalDetails: 'string',
            optionType: {
              optionTypeId: 'string',
              dateCreated: '2022-10-06T12:56:26.712Z',
              createdBy: 'string',
              optionTypeName: 'string',
            },
            parentOptionId: {},
          },
          headOfficeAddressState: {
            stateId: 'string',
            stateName: 'string',
            capital: 'string',
            dateCreated: '2022-10-06T12:56:26.712Z',
            createdBy: 'string',
            dateModified: '2022-10-06T12:56:26.712Z',
            modifiedBy: 'string',
            countryCode: {
              countryCode: 'string',
              countryName: 'string',
              unRegion: 'string',
              unSubregion: 'string',
            },
          },
        },
      },
      jpaWorkflowGroup: {
        jpaWorkflowGroupPK: {
          workflowGroupId: 'string',
          workflowType: 'string',
        },
        workflowGroupName: 'string',
        workflowGroupDescription: 'string',
        dateCreated: '2022-10-06T12:56:26.712Z',
        createdBy: 'string',
        dateModified: '2022-10-06T12:56:26.712Z',
        modifiedBy: 'string',
        active: true,
        collaboratorId: {
          collaboratorId: 'string',
          isGeneric: true,
          address: 'string',
          ordering: 0,
          dateModified: '2022-10-06T12:56:26.712Z',
          modifiedBy: 'string',
          dateCreated: '2022-10-06T12:56:26.712Z',
          createdBy: 'string',
          sector: {
            dateCreated: '2022-10-06T12:56:26.712Z',
            dateModified: '2022-10-06T12:56:26.712Z',
            modifiedBy: 'string',
            createdBy: 'string',
            optionId: 'string',
            optionName: 'string',
            optionDescription: 'string',
            actionAdditionalDetails: 'string',
            optionType: {
              optionTypeId: 'string',
              dateCreated: '2022-10-06T12:56:26.712Z',
              createdBy: 'string',
              optionTypeName: 'string',
            },
            parentOptionId: {},
          },
        },
        jpaWorkflowGroup: {},
      },
    },
    currentUserWatchingComplaint: true,
    contractorId: 'string',
    tradeName: 'string',
    rcNumber: 'string',
    tinNumber: 'string',
    dateOfRegistration: '2022-10-06T12:56:26.712Z',
    nccId: 'string',
    headOfficeAddressStreet: 'string',
    companyName: 'string',
    phoneNumber: 'string',
    fax: 'string',
    website: 'string',
    headOfficeAddressCity: 'string',
    headOfficeAddressZip: 'string',
    headOfficeAddressPobox: 'string',
    headOfficeAddressPmb: 'string',
    companyContactPhone1: 'string',
    companyContactPhone2: 'string',
    companyContactAlternativeEmail: 'string',
    companyContactEmail: 'string',
    barred: true,
    isLicensee: true,
    isCompanyRegVerified: true,
    oldContractorUsername: 'string',
    certificateNumber: 0,
    companyEmailVerified: true,
    registrationNumber: 'string',
    thirdPartyBusinessNumber: 'string',
    dateModified: '2022-10-06T12:56:26.712Z',
    modifiedBy: 'string',
    dateCreated: '2022-10-06T12:56:26.712Z',
    createdBy: 'string',
    countryOfRegistration: {
      countryCode: 'string',
      countryName: 'string',
      unRegion: 'string',
      unSubregion: 'string',
    },
    actualCompanyType: {
      dateCreated: '2022-10-06T12:56:26.712Z',
      dateModified: '2022-10-06T12:56:26.712Z',
      modifiedBy: 'string',
      createdBy: 'string',
      optionId: 'string',
      optionName: 'string',
      optionDescription: 'string',
      actionAdditionalDetails: 'string',
      optionType: {
        optionTypeId: 'string',
        dateCreated: '2022-10-06T12:56:26.712Z',
        createdBy: 'string',
        optionTypeName: 'string',
      },
      parentOptionId: {},
    },
    thirdPartyBusinessName: {
      dateCreated: '2022-10-06T12:56:26.712Z',
      dateModified: '2022-10-06T12:56:26.712Z',
      modifiedBy: 'string',
      createdBy: 'string',
      optionId: 'string',
      optionName: 'string',
      optionDescription: 'string',
      actionAdditionalDetails: 'string',
      optionType: {
        optionTypeId: 'string',
        dateCreated: '2022-10-06T12:56:26.712Z',
        createdBy: 'string',
        optionTypeName: 'string',
      },
      parentOptionId: {},
    },
    ownershipType: {
      dateCreated: '2022-10-06T12:56:26.712Z',
      dateModified: '2022-10-06T12:56:26.712Z',
      modifiedBy: 'string',
      createdBy: 'string',
      optionId: 'string',
      optionName: 'string',
      optionDescription: 'string',
      actionAdditionalDetails: 'string',
      optionType: {
        optionTypeId: 'string',
        dateCreated: '2022-10-06T12:56:26.712Z',
        createdBy: 'string',
        optionTypeName: 'string',
      },
      parentOptionId: {},
    },
    companyType: {
      dateCreated: '2022-10-06T12:56:26.712Z',
      dateModified: '2022-10-06T12:56:26.712Z',
      modifiedBy: 'string',
      createdBy: 'string',
      optionId: 'string',
      optionName: 'string',
      optionDescription: 'string',
      actionAdditionalDetails: 'string',
      optionType: {
        optionTypeId: 'string',
        dateCreated: '2022-10-06T12:56:26.712Z',
        createdBy: 'string',
        optionTypeName: 'string',
      },
      parentOptionId: {},
    },
    headOfficeAddressState: {
      stateId: 'string',
      stateName: 'string',
      capital: 'string',
      dateCreated: '2022-10-06T12:56:26.712Z',
      createdBy: 'string',
      dateModified: '2022-10-06T12:56:26.712Z',
      modifiedBy: 'string',
      countryCode: {
        countryCode: 'string',
        countryName: 'string',
        unRegion: 'string',
        unSubregion: 'string',
      },
    },
    returnUrl: 'string',
    complaintId: 'string',
    captcha: 'string',
    securityQuestion: 'string',
    securityAnswer: 'string',
    mobileNumber: 'string',
    firstName: 'string',
    lastName: 'string',
    middleName: 'string',
    username: 'string',
    appUserEmail: 'string',
    password: 'string',
    organizationShortName: 'string',
    organizationDescription: 'string',
    organizationLongName: 'string',
    validationKey: 'string',
  };
}
